import { Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./cart.css";
import { MyContextSupply } from "../../Context";
import CircularProgress from "@mui/material/CircularProgress";
import ShortDisplayReview from "../ReviewRating/ShortDisplayReview";
import ReviewFullAndAddNew from "../ReviewRating/ReviewFullAndAddNew";
import WriteReview from "../ReviewRating/WriteReview";
import "react-toastify/dist/ReactToastify.css";
import { MdRateReview, MdOutlinePreview } from "react-icons/md";


const Cart = () => {
  const { handleAddProduct, toggleRunPath, setIsProductAddPopUpOpen } =
    MyContextSupply();
  const { id } = useParams("");
  const navigate = useNavigate("");
  const [inddata, setIndedata] = useState("");
  const [loading, setLoading] = useState(false);
  const [isShowReview, setIsShowReview] = useState(false);
  const [isWriteReviewTrue, setIsWriteReviewTrue] = useState(false);

  const getinddata = async () => {
    setLoading(true);
    await axios
      .get(`https://stechbackend-9r4c.onrender.com/getproductsone/${id}`)
      .then((res) => {
        if (res) {
          setIndedata(res.data);
          setLoading(false);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  useEffect(() => {
    const tim = setTimeout(getinddata, 1.5);
    return () => {
      clearTimeout(tim);
    };
  }, [id]);

  const { _id, category, description, price, review, tagline, title, url } =
    inddata !== "" && inddata;


  return (
    <div className="cart_section">
      {!loading ? (
        <>
          <div className="cart_container">
            <div className="left_cart">
              <img src={url} alt="" />
              <div className="cart_btn">
                <button
                  className="cart_btn1"
                  onClick={() => {
                    handleAddProduct(inddata);
                    setIsProductAddPopUpOpen(true);
                  }}
                >
                  Add to Cart
                </button>
                <button
                  onClick={() => {
                    handleAddProduct(inddata);
                    navigate("/buynow");
                    toggleRunPath();
                  }}
                  className="cart_btn2"
                >
                  Buy Now
                </button>
              </div>
            </div>
            <div className="right_cart">
              <div className="right_cart_inside">
                <h3>{title?.longTitle}</h3>
                <div style={{ display: "flex", marginBottom: "5px" }}>
                  <p style={{ marginTop: "6px" }}> Ratings:</p>
                  <ShortDisplayReview review={review} fontSizeCustom={20} />
                </div>
                <div className="review-btns-add-show">
                  <button
                    onClick={() => setIsShowReview(true)}
                    className="write-a-review-btn"
                  >
                    <MdOutlinePreview className="review-write-icon" />
                    View All Reviews
                  </button>

                  <button
                    onClick={() => setIsWriteReviewTrue(true)}
                    className="write-a-review-btn"
                  >
                    <MdRateReview className="review-write-icon" /> Write a
                    Review
                  </button>
                </div>
                <Divider />
                <p className="mrp">M.R.P: ${price?.mrp}</p>
                <p>
                  Deal of the Day:
                  <span style={{ color: "red" }}>${price?.cost}</span>
                </p>
                <h5>
                  Discount:
                  {`${(((price?.mrp - price?.cost) / price?.mrp) * 100).toFixed(
                    2
                  )}`}
                  %
                </h5>
                <p>
                  Your save:
                  <span style={{ color: "blue" }}>
                    ${price?.mrp - price?.cost}
                  </span>
                </p>
                <div className="discount_box">
                  <h4 style={{ fontSize: "14px" }}>
                    Free Delivery:
                    <span style={{ color: "red", font: 600 }}>
                      Every Sunday
                    </span>
                  </h4>
                  <p>
                    Fastest delivery:
                    <span style={{ color: "blue", fontWeight: 600 }}>
                      Tomorrow 11am
                    </span>
                  </p>
                </div>
                <p className="description">
                  About the Item:
                  <span
                    style={{
                      color: "#504f4f",
                      fontSize: "16px",
                      fontWeight: 500,
                      letterSpacing: "0.2px",
                    }}
                  >
                    {description}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <ReviewFullAndAddNew
            review={review}
            isShowReview={isShowReview}
            setIsShowReview={setIsShowReview}
          />
          <WriteReview
            isWriteReviewTrue={isWriteReviewTrue}
            setIsWriteReviewTrue={setIsWriteReviewTrue}
            id={_id}
            inddata={inddata}
            setIndedata={setIndedata}
          />
          <div className="cart-full-footer-style">
            <h1 style={{ textAlign: "center" }}>{title?.shortTitle}</h1>
          </div>
        </>
      ) : (
        <div className="circle">
          <CircularProgress />
          <h2>Loading Data</h2>
        </div>
      )}
    </div>
  );
};

export default Cart;
